import type { Article } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

interface FeaturedGridProps {
  articles: Article[];
}

export default function FeaturedGrid({ articles }: FeaturedGridProps) {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8">
          <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">
            精选大瓜
          </h2>
          <p className="text-xs text-foreground-500 mt-1.5">编辑严选 · 绝不含糊</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <ArticleCard key={article.id} article={article} variant="grid" />
          ))}
        </div>

        <div className="mt-8 text-center">
          <a
            href="/category/today-hot"
            className="inline-flex items-center gap-1.5 px-6 py-2.5 rounded-full border border-foreground-300 text-foreground-600 text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200 hover:border-foreground-800 hover:text-foreground-800"
          >
            查看更多爆料
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}